var RelatedProducts = {
  instances: [],
  observers: [],

  init: function () {
    this.destroy();

    $('[data-related-products]').each(function () {
      RelatedProducts.observe(this);
      RelatedProducts.load(this);
      RelatedProducts.createSwiper(this);
    });
  },

  load: function (section) {
    if (
      section.querySelector('[data-related-products-swiper]') ||
      section.dataset.loading === 'true' ||
      !section.dataset.url
    ) {
      return;
    }

    section.dataset.loading = 'true';

    fetch(section.dataset.url)
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load related products');
        return response.text();
      })
      .then(function (text) {
        const html = document.createElement('div');
        html.innerHTML = text;
        const loadedSection = html.querySelector('[data-related-products]');
        const currentContent = section.querySelector('[data-related-products-content]');
        const loadedContent = loadedSection
          ? loadedSection.querySelector('[data-related-products-content]')
          : null;

        if (!currentContent || !loadedContent || !loadedContent.innerHTML.trim()) return;

        currentContent.innerHTML = loadedContent.innerHTML;
        RelatedProducts.createSwiper(section);

        if (window.HomeProducts && typeof HomeProducts.init === 'function') {
          HomeProducts.init();
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        delete section.dataset.loading;
      });
  },

  observe: function (section) {
    const observer = new MutationObserver(function () {
      RelatedProducts.createSwiper(section);

      if (window.HomeProducts && typeof HomeProducts.init === 'function') {
        HomeProducts.init();
      }
    });

    observer.observe(section, { childList: true, subtree: true });
    this.observers.push(observer);
  },

  createSwiper: function (section) {
    const swiperElement = section.querySelector('[data-related-products-swiper]');

    if (!swiperElement || typeof Swiper === 'undefined') return;

    if (window.innerWidth > 768) {
      if (swiperElement.swiper) {
        swiperElement.swiper.destroy(true, true);
      }
      return;
    }

    if (swiperElement.swiper) {
      swiperElement.swiper.update();
      return;
    }

    const swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: false
      },
      mousewheel: {
        invert: false,
        forceToAxis: true
      }
    });

    this.instances.push(swiper);
  },

  destroy: function () {
    this.instances.forEach(function (swiper) {
      if (swiper && !swiper.destroyed) {
        swiper.destroy(true, true);
      }
    });

    this.observers.forEach(function (observer) {
      observer.disconnect();
    });

    this.instances = [];
    this.observers = [];
  }
};

$(document).ready(function () {
  RelatedProducts.init();

  var resizeTimer;

  $(window).on('resize.relatedProducts', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      RelatedProducts.init();
    }, 200);
  });
});

$(document).on('shopify:section:load', function () {
  RelatedProducts.init();
});

$(document).on('shopify:section:unload', function () {
  RelatedProducts.destroy();
});
